import React from 'react';
import classNames from 'classnames';
import * as helper from '../../../Common/html-helper';
import { IL10N } from '../../../Common/l10n-keys';
import styles from './filterMatchOverview.scss';
import IFilterMatchOverview from './filterMatchOverview.d';
import EyecatcherPanel from '../eyecatcherPanel/eyecatcherPanel';

function FilterMatchCircle({ isMatch }: { isMatch: boolean }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
            <g>
                <circle className={isMatch ? styles.matching : styles.non_matching} cx="5" cy="5" r="4"/>
            </g>
        </svg>
    );
}

function Filter({ isMatch, filter, l10n }: { isMatch: boolean, filter: string, l10n: IL10N }) {
    const filterString = filter[0].toLowerCase() + filter.slice(1);

    return (
        <div className={styles.entry}>
            <FilterMatchCircle isMatch={isMatch}/>
            <span>{helper.decodeHTML(l10n[filterString] ? l10n[filterString] : filter)}</span>
        </div>
    )
}

function FilterMatchOverview(props: IFilterMatchOverview) {
    const { matchingFilters = [], nonMatchingFilters = [], l10n, percentagePoints } = props;

    return (
        <div className={styles.filter_match_overview}>
            <div className={styles.line}>
                <EyecatcherPanel
                    percentagePoints={percentagePoints}
                    proFeatureNumber = {matchingFilters.length}
                    contraFeatureNumber ={nonMatchingFilters.length}
                    totoalFeatureNumber ={matchingFilters.length + nonMatchingFilters.length} />
            </div>
            <div className={classNames(styles.line, styles.filter_list)}>
                <div className={styles.column}>{
                    matchingFilters.map((filter, index) =>
                        <Filter key={filter + index} isMatch={true} filter={filter} l10n={l10n}/>
                    )
                }</div>
                <div className={styles.column}>{
                    nonMatchingFilters.map((filter, index) =>
                        <Filter key={filter + index} isMatch={false} filter={filter} l10n={l10n}/>
                    )
                }</div>
            </div>
        </div>
    );
}

export default FilterMatchOverview
